/**
 * Login flow step constants
 * Used to track current step in multi-step login process
 */
export enum LoginStep {
  ROLE_SELECTION = 1,
  ADMIN_LOGIN = 2,
  STAFF_LOGIN = 3,
  OTP_VERIFICATION = 4,
  FORGOT_PASSWORD = 6,
  FORGOT_PASSWORD_OTP_1 = 7,
  FORGOT_PASSWORD_OTP_2 = 8,
  CREATE_NEW_PASSWORD = 9,
}

/**
 * Steps that should hide title/description and role selection
 */
export const STEPS_WITHOUT_HEADER = [
  LoginStep.OTP_VERIFICATION,
  LoginStep.FORGOT_PASSWORD,
  LoginStep.FORGOT_PASSWORD_OTP_1,
  LoginStep.FORGOT_PASSWORD_OTP_2,
  LoginStep.CREATE_NEW_PASSWORD,
]

/**
 * Initial step - defaults to staff login (employee)
 */
export const INITIAL_STEP = LoginStep.STAFF_LOGIN

/**
 * Role selection constants
 */
export enum LoginRole {
  EMPLOYEE = 0,
  MANAGER = 1,
}

